import $ from 'jquery';

const SELECTOR = {
    CONTAINER_SUBLEVEL: '.rsp_nav__list',
    BREADCRUMB_CHANNEL_IDS_SELECTOR: '#breadcrumb-channel-ids',
    DATA_CHANNEL_ID_ATTR: "data-channelid"
};

const CLASS = {
    IS_ACTIVE: 'is-active',
};

export default class NavPanelMobile {

    constructor() {
        var _self = this;
        _self.$panel = $(SELECTOR.CONTAINER_SUBLEVEL);
        _self.$lvlLinks = _self.$panel.find("li.rsp_nav__item[data-channelid]");
        _self.currentChannelBreadcrumb = $(SELECTOR.BREADCRUMB_CHANNEL_IDS_SELECTOR).val();
    }
    /**
     * Init App
     */
    init() {
        var _self = this;
        _self.bindEvents();
        _self.setActiveLink();
    }

    /**
     * Bind required events
     */
    bindEvents() {

		// On cache tous les menus
        $('.rsp_nav__item ul').hide();
		
		// On cache le menu à gauche (pro & ent) qd on clique sur btn burger, utilité ?
        // Pas faire ....off("click") comme clics déjà gérés en burgerBtn
        $('.rsp_btn.rsp_btn--burger.js-header-burger').on("click", function(){
            //$('.rsp_nav__item ul').slideUp();
            $('.rsp_nav__item ul').each(function(){
                if($(this).hasClass("rsp_menu-left_list")){
                    $(this).slideUp();
                }
            })
        });

		// Boutons menu - event click
        var allMenuBtns = $(".rsp_nav__item button.rsp_btn.rsp_btn--toggle.js-nav-mobile-first-lvl-btn");
        allMenuBtns.off("click");
        allMenuBtns.on("click",function(e) {
            e.stopPropagation();

			// Toggle menu on click
			var $myListe = $(this).next('ul.rsp_nav__list');
			$(this).attr('aria-expanded', ($myListe.css('display') == 'none') ? 'true' : 'false');
            $myListe.slideToggle();
			
			// If first level : close other first level
			if (!$(this).hasClass("rsp_btn--sub-level")) {
				var $mainLI = $(this).closest("li");
				
				// Les autres menus niv1 frères
				var $allMainLI = $mainLI.siblings();
				
					// Fermer les autres uls niv.1
					$allMainLI.find("ul.rsp_nav__list.js-nav-mobile-second-lvl-container").slideUp("100");
					// Fermer les autres boutons niv.1
					$allMainLI.find("button.rsp_btn.js-nav-mobile-first-lvl-btn").each(function(){
					if(!$(this).hasClass("rsp_btn--sub-level")){
						$(this).attr('aria-expanded','false'); //rsp_btn--toggle. & rsp_btn--emergency
					}
				})
			}
        });

		
		// Combo Autres sites
        var otherSite = $("button.rsp_btn.rsp_btn--emergency.js-nav-mobile-first-lvl-btn");
		// Par défaut fermé
		otherSite.attr('aria-expanded', 'false');
        otherSite.off("click");
        otherSite.on("click",function(e) {
            let attrSwitch = $(this).attr('aria-expanded');
            $(this).attr('aria-expanded', (attrSwitch === 'false') ? 'true' : 'false');
            $(this).next('#sub-list-otherSite_metiers, #sub-list-otherSite_regions').slideToggle();
        });
    }

    // Find active link between links with a page reference (data-channelid)
    setActiveLink() {
        var _self = this;
        if (_self.currentChannelBreadcrumb != undefined) {
            if (_self.$lvlLinks.length > 0) {
                _self.activateLinkWithChannelId(_self.$lvlLinks);
            }
        }
    }

    activateLinkWithChannelId($listLinks) {
        var _self = this;
        var currentChannelIds = _self.currentChannelBreadcrumb;

        $listLinks.each(function(index, element) {
            var currentChannelId = $(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
			// If line is current page
            if (currentChannelId !== "" && currentChannelIds.indexOf(currentChannelId) >= 0) {
				
				// Indicate actif line
                _self.$firstLinkActive = $(element);
                _self.$firstLinkActive.addClass(CLASS.IS_ACTIVE);
				
				// Open menu bottum-up
                _self.$firstLinkActive.parents("ul.rsp_nav__list").each(function(){
					$(this).show();
					$(this).prev("button").attr('aria-expanded','true');
				});

				// Indicate actif a link
                _self.$firstLinkActive.children("a").attr('aria-current','page');

            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/header/lhs/auth/navPanelMobile.js